<div class="privacy-modal">
  <motif-modal-title class="title" variant="alt">
    <div class="header-container">
      <motif-icon
        size="30"
        class="motif-icon"
        [iconFunction]="privacyPolicyIcon"
      ></motif-icon>
      <h2 class="header-title">
        {{ "PrivacyPolicy" | translate }}
      </h2>
    </div>

    <button
      *ngIf="isVisible"
      motifIconButton
      aria-label="Close modal"
      [motif-modal-close]="true"
      [size]="ButtonSizes.LARGE"
    >
      <motif-icon
        class="motif-modal-header-close-icon"
        [iconFunction]="IconoirXmark"
      ></motif-icon>
    </button>
  </motif-modal-title>

  <motif-modal-content>
    <div class="privacy-notice-content">
      <h3>{{ "IPORPrivacyNoticeHeading" | translate }}</h3>

      <h3>{{ "IPORPrivacySection1Title" | translate }}</h3>
      <p [innerHTML]="'IPORPrivacySection1P1' | translate"></p>

      <h3>{{ "IPORPrivacySection2Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection2P1" | translate }}</p>
      <p>{{ "IPORPrivacySection2P2" | translate }}</p>
      <p>{{ "IPORPrivacySection2P3" | translate }}</p>

      <h3>{{ "IPORPrivacySection3Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection3Intro" | translate }}</p>
      <ul>
        <li>{{ "IPORPrivacySection3Bullet1" | translate }}</li>
        <li>{{ "IPORPrivacySection3Bullet2" | translate }}</li>
        <li>{{ "IPORPrivacySection3Bullet3" | translate }}</li>
      </ul>
      <p>{{ "IPORPrivacySection3UsageTitle" | translate }}</p>
      <ul>
        <li>{{ "IPORPrivacySection3Usage1" | translate }}</li>
        <li>{{ "IPORPrivacySection3Usage2" | translate }}</li>
        <li>{{ "IPORPrivacySection3Usage3" | translate }}</li>
        <li>{{ "IPORPrivacySection3Usage4" | translate }}</li>
      </ul>
      <p>{{ "IPORPrivacySection3BasisIntro" | translate }}</p>
      <p>{{ "IPORPrivacySection3Basis" | translate }}</p>
      <p>{{ "IPORPrivacySection3Objection" | translate }}</p>

      <h3>{{ "IPORPrivacySection4Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection4Intro" | translate }}</p>
      <ul>
        <li>{{ "IPORPrivacySection4Bullet1" | translate }}</li>
        <li>{{ "IPORPrivacySection4Bullet2" | translate }}</li>
        <li>{{ "IPORPrivacySection4Bullet3" | translate }}</li>
        <li>{{ "IPORPrivacySection4Bullet4" | translate }}</li>
      </ul>
      <p>{{ "IPORPrivacySection4SourceTitle" | translate }}</p>
      <ul>
        <li>{{ "IPORPrivacySection4Source1" | translate }}</li>
        <li>{{ "IPORPrivacySection4Source2" | translate }}</li>
        <li>{{ "IPORPrivacySection4Source3" | translate }}</li>
      </ul>

      <h3>{{ "IPORPrivacySection5Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection5P1" | translate }}</p>
      <p>{{ "IPORPrivacySection5P2" | translate }}</p>

      <h3>{{ "IPORPrivacySection6Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection6Intro" | translate }}</p>
      <p>{{ "IPORPrivacySection6AccessTitle" | translate }}</p>
      <ul>
        <li>{{ "IPORPrivacySection6Access1" | translate }}</li>
        <li>{{ "IPORPrivacySection6Access2" | translate }}</li>
        <li>{{ "IPORPrivacySection6Access3" | translate }}</li>
        <li>{{ "IPORPrivacySection6Access4" | translate }}</li>
      </ul>
      <p [innerHTML]="'IPORPrivacySection6Transfer' | translate"></p>

      <h3>{{ "IPORPrivacySection7Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection7P1" | translate }}</p>
      <p>{{ "IPORPrivacySection7P2" | translate }}</p>

      <h3>{{ "IPORPrivacySection8Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection8P1" | translate }}</p>
      <p>{{ "IPORPrivacySection8P2" | translate }}</p>
      <p>{{ "IPORPrivacySection8P3" | translate }}</p>
      <ul>
        <li>{{ "IPORPrivacySection8Bullet1" | translate }}</li>
        <li>{{ "IPORPrivacySection8Bullet2" | translate }}</li>
        <li>{{ "IPORPrivacySection8Bullet3" | translate }}</li>
      </ul>
      <p>{{ "IPORPrivacySection8P4" | translate }}</p>

      <h3>{{ "IPORPrivacySection9Title" | translate }}</h3>
      <p [innerHTML]="'IPORPrivacySection9P1' | translate"></p>

      <h3>{{ "IPORPrivacySection10Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection10P1" | translate }}</p>

      <h3>{{ "IPORPrivacySection11Title" | translate }}</h3>
      <p>{{ "IPORPrivacySection11Intro" | translate }}</p>
      <ul>
        <li>{{ "IPORPrivacySection11Bullet1" | translate }}</li>
        <li>{{ "IPORPrivacySection11Bullet2" | translate }}</li>
        <li>{{ "IPORPrivacySection11Bullet3" | translate }}</li>
        <li>{{ "IPORPrivacySection11Bullet4" | translate }}</li>
        <li>{{ "IPORPrivacySection11Bullet5" | translate }}</li>
        <li>{{ "IPORPrivacySection11Bullet6" | translate }}</li>
      </ul>
      <p [innerHTML]="'IPORPrivacySection11Contact' | translate"></p>

      <h3>{{ "IPORPrivacySection12Title" | translate }}</h3>
      <p [innerHTML]="'IPORPrivacySection12P1' | translate"></p>
      <p>{{ "IPORPrivacySection12P2" | translate }}</p>
      <p [innerHTML]="'IPORPrivacySection12P3' | translate"></p>

      <h3>{{ "IPORPrivacySection13Title" | translate }}</h3>
      <p [innerHTML]="'IPORPrivacySection13P1' | translate"></p>

      <h3>{{ "IPORPrivacySection14Title" | translate }}</h3>
      <p #listItem [innerHTML]="'IPORPrivacySection14P1' | translate"></p>
    </div>
  </motif-modal-content>
  <div class="action-buttons">
    <motif-modal-actions>
      <button
        *ngIf="!isVisible"
        class="button"
        [ngClass]="{ actionBtn: !acceptDisabled, '': acceptDisabled }"
        motifButton
        color="primary"
        variant="stepper"
        type="button"
        aria-label="Accept"
        [motif-tooltip]="'Accept'"
        [hideIconClose]="true"
        placement="left"
        [disabled]="acceptDisabled"
        (click)="onAccept()"
        [motif-modal-close]="true"
      >
        Accept
      </button>

      <button
        *ngIf="!isVisible"
        class="button"
        motifButton
        color="secondary"
        variant="stepper"
        type="button"
        aria-label="Decline"
        [motif-tooltip]="'Decline'"
        [hideIconClose]="true"
        (click)="onDecline()"
      >
        Decline
      </button>
    </motif-modal-actions>
  </div>
</div>
